import { normalizeText } from "./normalizeText";

/** A run of `text`: either plain or matching the query. `start` is its offset in characters. */
export interface HighlightSegment {
  text: string;
  match: boolean;
  start: number;
}

/**
 * Splits `text` into plain and matching segments, ignoring case and accents.
 * Returns no segments when there is nothing to highlight.
 */
export function highlightSegments(text: string, query: string): HighlightSegment[] {
  const needle = normalizeText(query.trim());
  if (!needle || !text) return [];
  const chars = Array.from(text);
  const normalizedChars = chars.map(normalizeText);
  // Offsets stay aligned only while every character normalizes to exactly one character.
  if (normalizedChars.some((c) => c.length !== 1)) return [];
  const haystack = normalizedChars.join("");
  const slice = (from: number, to?: number): string => chars.slice(from, to).join("");
  const segments: HighlightSegment[] = [];
  let from = 0;
  let index = haystack.indexOf(needle);
  while (index >= 0) {
    if (index > from) segments.push({ text: slice(from, index), match: false, start: from });
    segments.push({ text: slice(index, index + needle.length), match: true, start: index });
    from = index + needle.length;
    index = haystack.indexOf(needle, from);
  }
  if (segments.length === 0) return [];
  if (from < chars.length) segments.push({ text: slice(from), match: false, start: from });
  return segments;
}
